import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AuthConstants } from './config/auth-config';
import { HttpService } from './http.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userData$: any;

  constructor(
    private httpService: HttpService,
    private storageService: StorageService,
    private router: Router,
  ) { }

  getUserData() {
    this.storageService.get(AuthConstants.AUTH).then((res: any) => {
    this.userData$.next(res);
    });
  }
  login(postData: any): Observable<any> {
    return this.httpService.post('login', postData);
  }
  customerChangePassword(postData?: any): Observable<any> {
    return this.httpService.post('changePassword',postData);
  }
  signup(postData: any): Observable<any> {
    return this.httpService.post('register', postData);
  }

  checkEmail(postData: any): Observable<any> {
    return this.httpService.post('inquire', postData);
  }

  logout() {
    //  this.storageService.clear();
    this.storageService.removeItem(AuthConstants.AUTH);
    this.router.navigate(['']);
  }

  snomedGet(query, limit = 15, skipTo = 0, returnLimit = 15): Observable<any> {
    if (!query) {
        return of(null);
    }
    return this.httpService.get ('search-global-universites?name=' + query);

}

}
